import { Component, HostBinding } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-info-group-key',
	templateUrl: './info-group-key.component.html',
	styleUrls: ['./info-group-key.component.scss'],
})
export class InfoGroupKeyComponent {

	@HostBinding('class') public readonly klassName: string = `qe-info-group-key`;
	@HostBinding('attr.role') public readonly ariaRole: string = `paragraph`;

	constructor() { }
}
